import React from "react";
import Modal from "react-bootstrap/Modal";
import { modalHelpOnChangeAction } from "./../../../stores/actions/modalOnChange";
import CalculationsPdf from "../../../../src/InputFileTemplate/Calculations.pdf";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "./helpStyle.scss";

class Help extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      activeTab: "revenue-parameters",
    };
  }

  /**
   * Get help content
   */
  getHelpContent() {
    return (
      <>
        <h5>Parameters</h5>
        <ul>
          <h5 className="mt-2 light-margin">
            <span>{"Revenue Parameters"}</span>
          </h5>
          <li>
            <span>{"Capture rate employed physicians: "}</span>
            {
              "the initial (Year 1) script capture that is expected achievable considering prescribing patterns, relationships, patient preference of physicians employed at the pharmacy."
            }
          </li>
          <li>
            <span>{"Capture rate contracted physicians: "}</span>
            {
              "the initial (Year 1) script capture that is expected achievable considering prescribing patterns, relationships, patient preference of physicians contracted at the pharmacy."
            }
          </li>
          <li>
            <span>{"Specialty drug inflation: "}</span>
            {
              "expected inflation of specialty drugs as an average across a 5 year horizon."
            }
          </li>
          <li>
            <span>{"Growth in capture rate over 5 years: "}</span>
            {
              "expected growth in capture rate of scripts as the pharmacy expands payor contracts, acquires access to LDD drugs and expands the referral base over time."
            }
          </li>
          <li>
            <span>{"LDD Discount: "}</span>
            {
              "the further percentage discount off of the Capture rate that accounts for limited distribution drugs that are typically unable to be dispensed by typical specialty pharmacies."
            }
          </li>
          <li>
            <span>{"Growth in specialty rate: "}</span>
            {
              "the industry evolution to greater volume of specialty drugs from tradition."
            }
          </li>
          <li>
            <span>{"Commercial % claims: "}</span>
            {
              " percentage of current patient population claims that are billed to Commercial Insurers."
            }
          </li>
          <li>
            <span>{"Medicare % claims: "}</span>
            {
              " percentage of current patient population claims that are billed to Medicare."
            }
          </li>
          <li>
            <span>{"Medicaid % claims: "}</span>
            {
              " percentage of current patient population claims that are billed to Medicaid."
            }
          </li>
          <li>
            <span>{"Self-Pay % claims: "}</span>
            {
              "percentage of current patient population claims that are billed to the patient."
            }
          </li>
          <li>
            <span>{"Non-start: "}</span>
            {"non start."}
          </li>
          <h5 className="mt-2 light-margin">
            <span>{"Margin & Profitability Assumptions"}</span>
          </h5>
          <li>
            <span>{"Commercial margin on specialty: "}</span>
            {"Commercial margin on specialty."}
          </li>
          <li>
            <span>{"Medicare margin on specialty: "}</span>
            {"Medicare margin on specialty."}
          </li>
          <li>
            <span>{"Medicaid margin on specialty: "}</span>
            {"Medicaid margin on specialty."}
          </li>
          <li>
            <span>{"DIR Fee: "}</span>
            {"DIR Fee."}
          </li>
        </ul>
        <h5>Revenue Variables</h5>
        <ul>
          <li>
            <span>{"Employed physicians: "}</span>
            {"Employed physicians."}
          </li>
          <li>
            <span>{"Non employed physicians: "}</span>
            {"Non employed physicians."}
          </li>
          <li>
            <span>{"Patients: "}</span>
            {"Patients Per Year - employed."}
          </li>
          <li>
            <span>{"Treatments: "}</span>
            {"Avg treatment duration (months)."}
          </li>
          <li>
            <span>{"Average revenue / RX: "}</span>
            {"Average revenue per script."}
          </li>
          <li>
            <span>{"RX Per Patient: "}</span>
            {"Scripts per patient month."}
          </li>
          <li>
            <span>{"Margin %: "}</span>
            {"Margin %."}
          </li>
        </ul>
      </>
    );
  }

  /**
   * Handle on close
   */
  handleClose = () => {
    this.setState({
      show: false,
    });
    this.props.setHelpClosed({ status: false });
  };

  /**
   * Ui elements rendering
   */
  render() {
    const { show } = this.state;

    return (
      <>
        <Modal
          className="modal-help"
          size="lg"
          show={show}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Help</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="body-content">{this.getHelpContent()}</div>
            <div className="footer-download text-left">
              <a
                href={CalculationsPdf}
                id="download-formula"
                download="Calculations.pdf"
              >
                Download Formulas used for calculation
              </a>
            </div>
            <div className="body-footer text-right">
              <Button
                type="button"
                className="submit-btn"
                size="sm"
                onClick={this.handleClose}
              >
                OK
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

/**
 * Dispath props
 * @param {*} dispatch dispath props
 */
const MapDispatchToProps = (dispatch) => {
  return {
    setHelpClosed: (params) =>
      dispatch(
        modalHelpOnChangeAction(params)
      ),
  };
};

Help.propTypes = {
  setHelpClosed: PropTypes.func.isRequired,
};

/**
 * Mapping redux state into props
 */
const MapStateToProps = () => {
  return {};
};

export default connect(MapStateToProps, MapDispatchToProps)(Help);
